import CostsAndStatisticsModal from './SimulationCostCalculatorModal';

export default CostsAndStatisticsModal;
